/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ApiErrorResponseWithMessage,
    ApiErrorResponseWithMessageFromJSON,
    ApiErrorResponseWithMessageToJSON,
} from '../models/ApiErrorResponseWithMessage';
import {
    type ClaimDto,
    ClaimDtoFromJSON,
    ClaimDtoToJSON,
} from '../models/ClaimDto';
import {
    type ClientAllClaimReadDto,
    ClientAllClaimReadDtoFromJSON,
    ClientAllClaimReadDtoToJSON,
} from '../models/ClientAllClaimReadDto';
import {
    type DataSourceLoadOptions,
    DataSourceLoadOptionsFromJSON,
    DataSourceLoadOptionsToJSON,
} from '../models/DataSourceLoadOptions';
import {
    type GroupCreateDto,
    GroupCreateDtoFromJSON,
    GroupCreateDtoToJSON,
} from '../models/GroupCreateDto';
import {
    type GroupReadDto,
    GroupReadDtoFromJSON,
    GroupReadDtoToJSON,
} from '../models/GroupReadDto';
import {
    type LoadResult,
    LoadResultFromJSON,
    LoadResultToJSON,
} from '../models/LoadResult';
import {
    type UserReadDto,
    UserReadDtoFromJSON,
    UserReadDtoToJSON,
} from '../models/UserReadDto';

export interface UiApiGroupsAddPostRequest {
    groupCreateDto: GroupCreateDto;
}

export interface UiApiGroupsGetByClaimsPostRequest {
    clientId: string;
    claimDto: Array<ClaimDto>;
}

export interface UiApiGroupsGroupIdDeleteRequest {
    groupId: string;
}

export interface UiApiGroupsIdClaimsDeleteRequest {
    id: string;
    clientAllClaimReadDto: Array<ClientAllClaimReadDto>;
}

export interface UiApiGroupsIdClaimsGetRequest {
    id: string;
}

export interface UiApiGroupsIdClaimsPostRequest {
    id: string;
    clientAllClaimReadDto: Array<ClientAllClaimReadDto>;
}

export interface UiApiGroupsIdGetRequest {
    id: string;
}

export interface UiApiGroupsIdPostRequest {
    id: string;
    groupCreateDto: GroupCreateDto;
}

export interface UiApiGroupsIdUsersDeleteRequest {
    id: string;
    requestBody: Array<string>;
}

export interface UiApiGroupsIdUsersGetRequest {
    id: string;
    clientId?: string;
}

export interface UiApiGroupsIdUsersPostRequest {
    id: string;
    requestBody: Array<string>;
}

export interface UiApiGroupsPostRequest {
    clientId?: string;
    dataSourceLoadOptions?: DataSourceLoadOptions;
}

/**
 * 
 */
export class UiApiGroupsApi extends runtime.BaseAPI {

    /**
     * Creates request options for uiApiGroupsAddPost without sending the request
     */
    async uiApiGroupsAddPostRequestOpts(requestParameters: UiApiGroupsAddPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['groupCreateDto'] == null) {
            throw new runtime.RequiredError(
                'groupCreateDto',
                'Required parameter "groupCreateDto" was null or undefined when calling uiApiGroupsAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/add`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GroupCreateDtoToJSON(requestParameters['groupCreateDto']),
        };
    }

    /**
     * Создание группы
     */
    async uiApiGroupsAddPostRaw(requestParameters: UiApiGroupsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupReadDto>> {
        const requestOptions = await this.uiApiGroupsAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupReadDtoFromJSON(jsonValue));
    }

    /**
     * Создание группы
     */
    async uiApiGroupsAddPost(requestParameters: UiApiGroupsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupReadDto> {
        const response = await this.uiApiGroupsAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsGetByClaimsPost without sending the request
     */
    async uiApiGroupsGetByClaimsPostRequestOpts(requestParameters: UiApiGroupsGetByClaimsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uiApiGroupsGetByClaimsPost().'
            );
        }

        if (requestParameters['claimDto'] == null) {
            throw new runtime.RequiredError(
                'claimDto',
                'Required parameter "claimDto" was null or undefined when calling uiApiGroupsGetByClaimsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['clientId'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/get-by-claims`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['claimDto']!.map(ClaimDtoToJSON),
        };
    }

    /**
     * Получение групп, содержащих **хотя бы одно** разрешение из переданной коллекции
     * Получение групп по разрешениям
     */
    async uiApiGroupsGetByClaimsPostRaw(requestParameters: UiApiGroupsGetByClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupReadDto>>> {
        const requestOptions = await this.uiApiGroupsGetByClaimsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupReadDtoFromJSON));
    }

    /**
     * Получение групп, содержащих **хотя бы одно** разрешение из переданной коллекции
     * Получение групп по разрешениям
     */
    async uiApiGroupsGetByClaimsPost(requestParameters: UiApiGroupsGetByClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupReadDto>> {
        const response = await this.uiApiGroupsGetByClaimsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsGroupIdDelete without sending the request
     */
    async uiApiGroupsGroupIdDeleteRequestOpts(requestParameters: UiApiGroupsGroupIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling uiApiGroupsGroupIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/groups/{groupId}`;
        urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Удаление группы
     */
    async uiApiGroupsGroupIdDeleteRaw(requestParameters: UiApiGroupsGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiGroupsGroupIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Удаление группы
     */
    async uiApiGroupsGroupIdDelete(requestParameters: UiApiGroupsGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiGroupsGroupIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiGroupsIdClaimsDelete without sending the request
     */
    async uiApiGroupsIdClaimsDeleteRequestOpts(requestParameters: UiApiGroupsIdClaimsDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdClaimsDelete().'
            );
        }

        if (requestParameters['clientAllClaimReadDto'] == null) {
            throw new runtime.RequiredError(
                'clientAllClaimReadDto',
                'Required parameter "clientAllClaimReadDto" was null or undefined when calling uiApiGroupsIdClaimsDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/{id}/claims`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['clientAllClaimReadDto']!.map(ClientAllClaimReadDtoToJSON),
        };
    }

    /**
     * Если **хоть один** клейм из списка не будет найден - ничего не удалится
     * Удаление списка клеймов группы
     */
    async uiApiGroupsIdClaimsDeleteRaw(requestParameters: UiApiGroupsIdClaimsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiGroupsIdClaimsDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Если **хоть один** клейм из списка не будет найден - ничего не удалится
     * Удаление списка клеймов группы
     */
    async uiApiGroupsIdClaimsDelete(requestParameters: UiApiGroupsIdClaimsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiGroupsIdClaimsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiGroupsIdClaimsGet without sending the request
     */
    async uiApiGroupsIdClaimsGetRequestOpts(requestParameters: UiApiGroupsIdClaimsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdClaimsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/groups/{id}/claims`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение клеймов группы
     */
    async uiApiGroupsIdClaimsGetRaw(requestParameters: UiApiGroupsIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientAllClaimReadDto>>> {
        const requestOptions = await this.uiApiGroupsIdClaimsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientAllClaimReadDtoFromJSON));
    }

    /**
     * Получение клеймов группы
     */
    async uiApiGroupsIdClaimsGet(requestParameters: UiApiGroupsIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientAllClaimReadDto>> {
        const response = await this.uiApiGroupsIdClaimsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsIdClaimsPost without sending the request
     */
    async uiApiGroupsIdClaimsPostRequestOpts(requestParameters: UiApiGroupsIdClaimsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdClaimsPost().'
            );
        }

        if (requestParameters['clientAllClaimReadDto'] == null) {
            throw new runtime.RequiredError(
                'clientAllClaimReadDto',
                'Required parameter "clientAllClaimReadDto" was null or undefined when calling uiApiGroupsIdClaimsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/{id}/claims`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['clientAllClaimReadDto']!.map(ClientAllClaimReadDtoToJSON),
        };
    }

    /**
     * Добавление клеймов группы
     */
    async uiApiGroupsIdClaimsPostRaw(requestParameters: UiApiGroupsIdClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiGroupsIdClaimsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Добавление клеймов группы
     */
    async uiApiGroupsIdClaimsPost(requestParameters: UiApiGroupsIdClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiGroupsIdClaimsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiGroupsIdGet without sending the request
     */
    async uiApiGroupsIdGetRequestOpts(requestParameters: UiApiGroupsIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение группы
     */
    async uiApiGroupsIdGetRaw(requestParameters: UiApiGroupsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupReadDto>> {
        const requestOptions = await this.uiApiGroupsIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupReadDtoFromJSON(jsonValue));
    }

    /**
     * Получение группы
     */
    async uiApiGroupsIdGet(requestParameters: UiApiGroupsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupReadDto> {
        const response = await this.uiApiGroupsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsIdPost without sending the request
     */
    async uiApiGroupsIdPostRequestOpts(requestParameters: UiApiGroupsIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdPost().'
            );
        }

        if (requestParameters['groupCreateDto'] == null) {
            throw new runtime.RequiredError(
                'groupCreateDto',
                'Required parameter "groupCreateDto" was null or undefined when calling uiApiGroupsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GroupCreateDtoToJSON(requestParameters['groupCreateDto']),
        };
    }

    /**
     * Обновление группы
     */
    async uiApiGroupsIdPostRaw(requestParameters: UiApiGroupsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiGroupsIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Обновление группы
     */
    async uiApiGroupsIdPost(requestParameters: UiApiGroupsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiGroupsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsIdUsersDelete without sending the request
     */
    async uiApiGroupsIdUsersDeleteRequestOpts(requestParameters: UiApiGroupsIdUsersDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdUsersDelete().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling uiApiGroupsIdUsersDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/{id}/users`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Удаление пользователей из группы
     */
    async uiApiGroupsIdUsersDeleteRaw(requestParameters: UiApiGroupsIdUsersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiGroupsIdUsersDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Удаление пользователей из группы
     */
    async uiApiGroupsIdUsersDelete(requestParameters: UiApiGroupsIdUsersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiGroupsIdUsersDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiGroupsIdUsersGet without sending the request
     */
    async uiApiGroupsIdUsersGetRequestOpts(requestParameters: UiApiGroupsIdUsersGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdUsersGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['clientId'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/groups/{id}/users`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение пользователей группы
     */
    async uiApiGroupsIdUsersGetRaw(requestParameters: UiApiGroupsIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserReadDto>>> {
        const requestOptions = await this.uiApiGroupsIdUsersGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserReadDtoFromJSON));
    }

    /**
     * Получение пользователей группы
     */
    async uiApiGroupsIdUsersGet(requestParameters: UiApiGroupsIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserReadDto>> {
        const response = await this.uiApiGroupsIdUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiGroupsIdUsersPost without sending the request
     */
    async uiApiGroupsIdUsersPostRequestOpts(requestParameters: UiApiGroupsIdUsersPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiGroupsIdUsersPost().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling uiApiGroupsIdUsersPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups/{id}/users`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Добавление пользователей группы
     */
    async uiApiGroupsIdUsersPostRaw(requestParameters: UiApiGroupsIdUsersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiGroupsIdUsersPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Добавление пользователей группы
     */
    async uiApiGroupsIdUsersPost(requestParameters: UiApiGroupsIdUsersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiGroupsIdUsersPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiGroupsPost without sending the request
     */
    async uiApiGroupsPostRequestOpts(requestParameters: UiApiGroupsPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['clientId'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/groups`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Поля объекта \"группа\":  ```  {    id: string;    clientId: string;    createdDate: string;    name: string;    description: string;  }  ```
     * Список групп
     */
    async uiApiGroupsPostRaw(requestParameters: UiApiGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadResult>> {
        const requestOptions = await this.uiApiGroupsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadResultFromJSON(jsonValue));
    }

    /**
     * Поля объекта \"группа\":  ```  {    id: string;    clientId: string;    createdDate: string;    name: string;    description: string;  }  ```
     * Список групп
     */
    async uiApiGroupsPost(requestParameters: UiApiGroupsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadResult> {
        const response = await this.uiApiGroupsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
